export default "__VITE_ASSET__BXYt2czD__"